import { createSlice } from '@reduxjs/toolkit';
import { initialFiltersState } from './filters';
import {initialModeState} from "./mode";
import {initialDataState} from "./data";

const filtersSecondLvlSlice = createSlice({
  name: 'filtersSecondLvl',
  initialState: initialFiltersState,
  reducers: {
    applyFilters(state, action) {
      for (const [key, value] of Object.entries(action.payload)) {
        state[key] = value;
      }
    },
  },
});

const modeSecondLvlSlice = createSlice({
  name: 'modeSecondLvl',
  initialState: initialModeState,
  reducers: {
    applyMode(state, action) {
      state.mode = action.payload;
    },
  },
});

const dataSecondLvlSlice = createSlice({
  name: 'dataSecondLvl',
  initialState: initialDataState,
  reducers: {
    applyFilteredShape(state, action) {
      state.filteredShape = action.payload;
    },
  },
});

export const filtersSecondLvlActions = filtersSecondLvlSlice.actions;
export const modeSecondLvlActions = modeSecondLvlSlice.actions;
export const dataSecondLvlActions = dataSecondLvlSlice.actions;

export const filtersSecondLvlReducer = filtersSecondLvlSlice.reducer;
export const modeSecondLvlReducer = modeSecondLvlSlice.reducer;
export const dataSecondLvlReducer = dataSecondLvlSlice.reducer;
